module.exports = __webpack_public_path__ + "static/media/robson.76ae444d.jpg";